<template>
    <div>
        <navbar/>
        <error-panel showInPopup="false" />
        <Spinner :loaded="loaded" />
        <main v-if="loaded" role="main"  >
            <div class="jumbotron" id="tl-jumbotron">
                <div class="container">
                    <div class="row tl-link-block tl-link-block-header pb-1 mb-3">
                        <h4 class="col-12 mb-2">
                            <span class="bi bi-tags-fill text-warning mr-2"/>
                            My tags
                        </h4>
                        <div class="col-12 pb-1 mb-1">
                            <span class="tl-subtext-header">My tags ordered by usage count</span>
                        </div>
                    </div>

                    <EmptyState v-if="tagCounts.length == 0"/>

                    <div class="tl-link-block row p-3" >
                        <div class="col-12 pb-1 mb-2 ml-0 mr-0 pl-1 pr-1">
                            <input type="text"
                                   class="form-control"
                                   v-model="searchTerm"
                                   placeholder="start typing to filter tags..."/>
                        </div>
                        <div
                        v-for="item in this.sortedAndFilteredTags"
                        :key="item[0]"
                        class="tag-container">
                            <a
                            :style="calculateFontSize(item[1])"
                            class="badge tl-badge tl-tag icon-grow"
                            :href="createLink(item[0])">{{item[0]}}
                                <sup>{{item[1]}}</sup>
                            </a>
                        </div>
                        <div class="m-3 text-muted bi bi-error" v-if="sortedAndFilteredTags.length === 0"><i class="bi bi-emoji-astonished mr-2"></i>Couldn't find anything...</div>
                    </div>
                </div>
            </div>
        </main>
        <tlfooter v-if="loaded" />
  </div>
</template>

<script>
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";
import ErrorPanel from "@/components/ErrorPanel";
import BackendClient from "@/rest/backend-client";
import EmptyState from "@/components/EmptyState";
import Spinner from "@/components/Spinner";

export default {
  name: "TagCloud",
  head: {
    title: 'just bookmark it! - my tags'
  },
  props: ['owner'],
  components: {
      ErrorPanel, navbar, tlfooter, EmptyState, Spinner
    },
  data() {
    return {
        tagCounts : null,
        loaded: false,
        searchTerm: ""
    }
  },
  mounted () {
      new BackendClient().getTagCounts().then(response => {
        this.tagCounts = response.data;
        this.loaded = true;
      })
    },
  computed: {
    sortedAndFilteredTags() {
        if (this.tagCounts == null) return [];
        const sorted = Object.entries(this.tagCounts).sort(([,a],[,b]) => b-a)
        return sorted.filter(item => item[0].toLowerCase().includes(this.searchTerm.toLowerCase()));
    }
  },
  methods: {
    createLink(tag) {
        return `/bookmarks/${this.owner}/tag/${tag}`
    },
    calculateFontSize(tagCount) {
        return {fontSize: Math.max(Math.min(tagCount, 32), 20)/20 + 'em'}
    }
  }
}
</script>

<style scoped>
 #tagCloud {
    margin: 10px;
 }
 .tag-container {
    margin: 5px;
 }
</style>
